import React, { useState } from "react";
import { useT, useLang } from "../context/LanguageContext";
import { t } from "../data/translations";
import ImageGallery from "../components/common/ImageGallery";

const Certificate = () => {
    const tr = useT();
    const { lang } = useLang();
    const [regFailed, setRegFailed] = useState(false);

    return (
        <div>
            {/* Page header */}
            <section className="bg-gradient-to-br from-slate-900 to-red-900 text-white">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-20">
                    <div className="text-xs uppercase tracking-widest text-amber-300 font-bold mb-3">
                        {tr(t.org.regNo)}
                    </div>
                    <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight">
                        {tr(t.certificate.title)}
                    </h1>
                    <p className="mt-3 text-slate-300 max-w-2xl">{tr(t.certificate.subtitle)}</p>
                </div>
            </section>

            {/* Registration Certificate */}
            <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-20">
                <div className="text-xs uppercase tracking-widest text-amber-600 font-bold mb-2">
                    {tr(t.certificate.registration)}
                </div>
                <h2 className="text-3xl sm:text-4xl font-bold text-slate-900 mb-8">
                    {tr(t.certificate.registration)}
                </h2>

                {!regFailed ? (
                    <div className="max-w-2xl">
                            <img
                                src="/images/certificates/registration-certificate.jpg"
                                alt={tr(t.certificate.registration)}
                                className="h-200 w-full object-cover"
                                onError={() => setRegFailed(true)}
                            />
                    </div>
                ) : (
                    <p className="text-slate-500 text-sm italic">
                        {lang === "mr"
                            ? "प्रमाणपत्र लवकरच अपलोड केले जाईल."
                            : "Certificate will be uploaded soon."}
                    </p>
                )}
            </section>

            {/* Other certificates */}
            <section className="bg-slate-50 border-y border-slate-200">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-20">
                    <h2 className="text-3xl sm:text-4xl font-bold text-slate-900 mb-8">
                        {tr(t.certificate.others)}
                    </h2>
                    <ImageGallery
                        folder="certificates"
                        prefix="cert-"
                        max={20}
                        altPrefix={tr(t.certificate.title)}
                        gridClassName="grid-cols-1 sm:grid-cols-2 lg:grid-cols-3"
                        imageClassName="h-80 sm:h-96"
                        fitClassName="object-contain"
                        emptyMessage={
                            lang === "mr"
                                ? "सध्या इतर प्रमाणपत्रे उपलब्ध नाहीत."
                                : "No other certificates uploaded yet."
                        }
                    />
                </div>
            </section>
        </div>
    );
};

export default Certificate;
